var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1da1f2",
  d: "M143.62 47.36c.098 1.41.098 2.822.098 4.245 0 43.375-33.02 93.4-93.4 93.4v-.026A92.93 92.93 0 0 1 0 130.263a66.774 66.774 0 0 0 7.813.474 65.916 65.916 0 0 0 40.769-14.079 32.867 32.867 0 0 1-30.668-22.796 32.72 32.72 0 0 0 14.82-.565A32.829 32.829 0 0 1 6.403 61.12v-.416A32.619 32.619 0 0 0 21.3 64.813a32.867 32.867 0 0 1-10.16-43.83 93.168 93.168 0 0 0 67.653 34.295 32.857 32.857 0 0 1 55.94-29.94 65.868 65.868 0 0 0 20.846-7.969 32.949 32.949 0 0 1-14.43 18.155A65.282 65.282 0 0 0 160 30.356a66.689 66.689 0 0 1-16.38 17.005Z"
})));

export default SvgTwitter;